// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const MOE_FONTE_COTACAO = {
  OlindaBCB: 'MOE_FONTE_COTACAO1',
  Manual: 'MOE_FONTE_COTACAO3',
  AwesomeAPI: 'MOE_FONTE_COTACAO4',
  AutomaticaMesmaMoeda: 'MOE_FONTE_COTACAO5',
  SgsBCB: 'MOE_FONTE_COTACAO2',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    MOE_FONTE_COTACAO1: 1,
    MOE_FONTE_COTACAO3: 3,
    MOE_FONTE_COTACAO4: 4,
    MOE_FONTE_COTACAO5: 5
  }
}
